import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  Output
} from '@angular/core';
import {ReferenceService} from '../../../apiModule1';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {JsonPipe} from '@angular/common';

@Component({
  selector: 'pas-unit-selector',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    JsonPipe
  ],
  templateUrl: './unit-selector.component.html',
  styleUrl: './unit-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitSelectorComponent {
  _units: Unit[] = [];
  @Input({required: true}) set units(v: Unit[]){
    this._units = v||[];
    this.cdr.markForCheck();
  };
  @Input({required: true}) unit?: Unit;
  @Output() unitChange = new EventEmitter<Unit>();


  form = new FormGroup({
    unitControl: new FormControl(this.unit)
  })

  get unitSelect(): Unit|null|undefined { return this.form.get('unitControl')?.value ; }

  constructor(private cdr: ChangeDetectorRef,) {
    this.form.valueChanges.subscribe((v) => {
      console.log('form.valueChanges',v, this.unitSelect);
      this.unitSelect && this.unitChange.emit(this.unitSelect);
    })
  }


}
